var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreventieWetten(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 375 203",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Preventie",
    transform: "translate(1.210000, -86.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "thema",
    transform: "translate(100.050000, 113.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.16,110.32 L79.16,119.43 L68.32,119.43 L68.32,110.32 L79.16,110.32 M80.66,108.82 L66.82,108.82 L66.82,120.93 L80.66,120.93 L80.66,108.82 L80.66,108.82 Z",
    id: "Shape",
    fill: "#E9B400",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 73.57,
    cy: 103.67,
    r: 3.46
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "77.15 115.74 77.15 127.79 70.4 127.79 70.4 115.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.16,110.32 L142.16,119.43 L131.32,119.43 L131.32,110.32 L142.16,110.32 M143.66,108.82 L129.82,108.82 L129.82,120.93 L143.66,120.93 L143.66,108.82 L143.66,108.82 Z",
    id: "Shape",
    fill: "#E9B400",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 136.57,
    cy: 103.67,
    r: 3.46
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "140.15 115.74 140.15 127.79 133.4 127.79 133.4 115.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.68,110.32 L206.68,119.43 L195.84,119.43 L195.84,110.32 L206.68,110.32 M208.18,108.82 L194.34,108.82 L194.34,120.93 L208.18,120.93 L208.18,108.82 L208.18,108.82 Z",
    id: "Shape",
    fill: "#E9B400",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 201.09,
    cy: 103.67,
    r: 3.46
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "204.67 115.74 204.67 127.79 197.92 127.79 197.92 115.74"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 21.53,
    cy: 47.9,
    r: 3.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.15,
    y1: 65.67,
    x2: 18.15,
    y2: 58.89,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.92,
    y1: 58.89,
    x2: 24.92,
    y2: 65.67,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 7.95,
    cy: 47.9,
    r: 3.39
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    points: "11.33 65.67 1.17 65.67 1.17 53.81 14.72 53.81 14.72 61.58"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.56,
    y1: 65.67,
    x2: 4.56,
    y2: 58.89,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.33,
    y1: 58.89,
    x2: 11.33,
    y2: 65.67,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 14.74,
    cy: 65.67,
    r: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    x: 7.96,
    y: 71.63,
    width: 13.55,
    height: 11.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.35,
    y1: 83.49,
    x2: 11.35,
    y2: 76.71,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.13,
    y1: 76.71,
    x2: 18.13,
    y2: 83.49,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    points: "14.76 61.6 14.76 53.81 28.31 53.81 28.31 65.67 18.15 65.67"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 80.53,
    cy: 47.9,
    r: 3.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.15,
    y1: 65.67,
    x2: 77.15,
    y2: 58.89,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.92,
    y1: 58.89,
    x2: 83.92,
    y2: 65.67,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 66.95,
    cy: 47.9,
    r: 3.39
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    points: "70.33 65.67 60.17 65.67 60.17 53.81 73.72 53.81 73.72 61.58"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.56,
    y1: 65.67,
    x2: 63.56,
    y2: 58.89,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.33,
    y1: 58.89,
    x2: 70.33,
    y2: 65.67,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 73.74,
    cy: 65.67,
    r: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    x: 66.96,
    y: 71.63,
    width: 13.55,
    height: 11.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.35,
    y1: 83.49,
    x2: 70.35,
    y2: 76.71,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.13,
    y1: 76.71,
    x2: 77.13,
    y2: 83.49,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    points: "73.76 61.6 73.76 53.81 87.31 53.81 87.31 65.67 77.15 65.67"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 143.53,
    cy: 47.9,
    r: 3.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.15,
    y1: 65.67,
    x2: 140.15,
    y2: 58.89,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.92,
    y1: 58.89,
    x2: 146.92,
    y2: 65.67,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 129.95,
    cy: 47.9,
    r: 3.39
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    points: "133.33 65.67 123.17 65.67 123.17 53.81 136.72 53.81 136.72 61.58"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.56,
    y1: 65.67,
    x2: 126.56,
    y2: 58.89,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.33,
    y1: 58.89,
    x2: 133.33,
    y2: 65.67,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 136.74,
    cy: 65.67,
    r: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    x: 129.96,
    y: 71.63,
    width: 13.55,
    height: 11.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.35,
    y1: 83.49,
    x2: 133.35,
    y2: 76.71,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.13,
    y1: 76.71,
    x2: 140.13,
    y2: 83.49,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    points: "136.76 61.6 136.76 53.81 150.31 53.81 150.31 65.67 140.15 65.67"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 136.68,
    cy: 3.83,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 136.8,
    cy: 13.74,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 136.68,
    cy: 23.65,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 146.17,
    cy: 4.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 127.22,
    cy: 23.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 146.65,
    cy: 13.68,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 126.83,
    cy: 13.68,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 146.26,
    cy: 23.17,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 127.31,
    cy: 4.23,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 73.68,
    cy: 3.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 73.8,
    cy: 13.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 73.68,
    cy: 23.82,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 83.17,
    cy: 4.39,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 64.22,
    cy: 23.33,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 83.65,
    cy: 13.84,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 63.83,
    cy: 13.84,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 83.26,
    cy: 23.33,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 64.31,
    cy: 4.39,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 13.68,
    cy: 3.99,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 13.8,
    cy: 13.91,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 13.68,
    cy: 23.82,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 23.17,
    cy: 4.39,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 4.22,
    cy: 23.33,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 23.65,
    cy: 13.84,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 3.83,
    cy: 13.84,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 23.26,
    cy: 23.33,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    cx: 4.31,
    cy: 4.39,
    r: 3.83
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.16,151.41 L79.16,160.52 L68.32,160.52 L68.32,151.41 L79.16,151.41 M80.66,149.91 L66.82,149.91 L66.82,162.02 L80.66,162.02 L80.66,149.91 L80.66,149.91 Z",
    id: "Shape",
    fill: "#E9B400",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 73.57,
    cy: 151.46,
    r: 3.46
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "77.15 156.83 77.15 168.88 70.4 168.88 70.4 156.83"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.8,
    y1: 161.65,
    x2: 79.8,
    y2: 169.77,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.16,151.41 L142.16,160.52 L131.32,160.52 L131.32,151.41 L142.16,151.41 M143.66,149.91 L129.82,149.91 L129.82,162.02 L143.66,162.02 L143.66,149.91 L143.66,149.91 Z",
    id: "Shape",
    fill: "#E9B400",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 136.57,
    cy: 151.46,
    r: 3.46
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "140.15 156.83 140.15 168.88 133.4 168.88 133.4 156.83"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.8,
    y1: 161.65,
    x2: 142.8,
    y2: 169.77,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.68,151.41 L206.68,160.52 L195.84,160.52 L195.84,151.41 L206.68,151.41 M208.18,149.91 L194.34,149.91 L194.34,162.02 L208.18,162.02 L208.18,149.91 L208.18,149.91 Z",
    id: "Shape",
    fill: "#E9B400",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 201.09,
    cy: 151.46,
    r: 3.46
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "204.67 156.83 204.67 168.88 197.92 168.88 197.92 156.83"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 207.32,
    y1: 161.65,
    x2: 207.32,
    y2: 169.77,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.16,151.41 L268.16,160.52 L257.32,160.52 L257.32,151.41 L268.16,151.41 M269.66,149.91 L255.82,149.91 L255.82,162.02 L269.66,162.02 L269.66,149.91 L269.66,149.91 Z",
    id: "Shape",
    fill: "#E9B400",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 262.57,
    cy: 151.46,
    r: 3.46
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "266.15 156.83 266.15 168.88 259.4 168.88 259.4 156.83"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.8,
    y1: 161.65,
    x2: 268.8,
    y2: 169.77,
    id: "Path",
    stroke: "#E9B400",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "tekst",
    fill: "#1D1D1B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7,123.16 C35.7,124.63 34.59,125.62 33.14,125.62 C31.69,125.62 30.59,124.63 30.59,123.16 L30.59,118.44 L31.67,118.44 L31.67,123.11 C31.67,124.06 32.25,124.65 33.14,124.65 C34.03,124.65 34.62,124.06 34.62,123.11 L34.62,118.44 L35.7,118.44 L35.7,123.16 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.93,120.89 C41.32,121.27 41.44,121.75 41.44,122.32 L41.44,125.56 L40.42,125.56 L40.42,122.47 C40.42,121.68 39.97,121.34 39.4,121.34 C38.83,121.34 38.35,121.69 38.35,122.47 L38.35,125.56 L37.33,125.56 L37.33,120.49 L38.33,120.49 L38.33,121 C38.68,120.62 39.17,120.43 39.68,120.43 C40.19,120.43 40.63,120.6 40.93,120.89 L40.93,120.89 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.06,119.49 L42.98,119.49 L42.98,118.41 L44.06,118.41 L44.06,119.49 Z M44.03,125.56 L43.01,125.56 L43.01,120.49 L44.03,120.49 L44.03,125.56 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "47.61 125.56 46.78 125.56 44.92 120.49 46 120.49 47.2 124.06 48.39 120.49 49.47 120.49 47.61 125.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.01,123.32 C51.01,124.2 51.46,124.74 52.3,124.74 C52.87,124.74 53.17,124.58 53.53,124.22 L54.18,124.83 C53.66,125.35 53.17,125.62 52.28,125.62 C51.01,125.62 50,124.95 50,123.02 C50,121.37 50.85,120.43 52.15,120.43 C53.45,120.43 54.3,121.41 54.3,122.89 L54.3,123.32 L51.01,123.32 Z M53.15,121.92 C52.98,121.54 52.63,121.28 52.15,121.28 C51.67,121.28 51.31,121.54 51.14,121.92 C51.04,122.14 51.02,122.3 51.01,122.61 L53.29,122.61 C53.27,122.3 53.25,122.14 53.15,121.92 L53.15,121.92 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.22,120.91 L58.45,121.68 C58.22,121.45 58.04,121.34 57.69,121.34 C57.14,121.34 56.68,121.78 56.68,122.48 L56.68,125.56 L55.66,125.56 L55.66,120.49 L56.66,120.49 L56.66,121.04 C56.92,120.68 57.44,120.43 58.01,120.43 C58.5,120.43 58.87,120.56 59.22,120.91 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5,121 L62.86,121.65 C62.54,121.38 62.09,121.28 61.61,121.28 C60.99,121.28 60.69,121.54 60.69,121.93 C60.69,122.28 60.89,122.46 61.39,122.51 L62.1,122.57 C63.15,122.66 63.7,123.12 63.7,124.01 C63.7,125.07 62.8,125.62 61.59,125.62 C60.76,125.62 60.06,125.48 59.46,124.89 L60.13,124.22 C60.54,124.64 61.09,124.75 61.59,124.75 C62.22,124.75 62.7,124.53 62.7,124.05 C62.7,123.7 62.51,123.5 62.02,123.45 L61.21,123.38 C60.25,123.29 59.71,122.87 59.71,121.98 C59.71,120.98 60.56,120.43 61.62,120.43 C62.39,120.43 63.03,120.59 63.5,121 L63.5,121 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.69,123.32 C65.69,124.2 66.14,124.74 66.98,124.74 C67.55,124.74 67.85,124.58 68.21,124.22 L68.86,124.83 C68.34,125.35 67.85,125.62 66.96,125.62 C65.69,125.62 64.68,124.95 64.68,123.02 C64.68,121.37 65.53,120.43 66.83,120.43 C68.13,120.43 68.98,121.41 68.98,122.89 L68.98,123.32 L65.69,123.32 Z M67.83,121.92 C67.66,121.54 67.31,121.28 66.83,121.28 C66.35,121.28 65.99,121.54 65.82,121.92 C65.72,122.14 65.7,122.3 65.69,122.61 L67.97,122.61 C67.95,122.3 67.93,122.14 67.83,121.92 L67.83,121.92 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.33,123.93 C71.33,124.47 71.47,124.65 71.88,124.65 L72.33,124.65 L72.33,125.56 L71.77,125.56 C70.79,125.56 70.31,125.02 70.31,123.99 L70.31,118.44 L71.33,118.44 L71.33,123.93 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1,123.32 C74.1,124.2 74.55,124.74 75.39,124.74 C75.96,124.74 76.26,124.58 76.62,124.22 L77.27,124.83 C76.75,125.35 76.26,125.62 75.37,125.62 C74.1,125.62 73.09,124.95 73.09,123.02 C73.09,121.37 73.94,120.43 75.24,120.43 C76.54,120.43 77.39,121.41 77.39,122.89 L77.39,123.32 L74.1,123.32 Z M76.24,121.92 C76.07,121.54 75.72,121.28 75.24,121.28 C74.76,121.28 74.4,121.54 74.23,121.92 C74.13,122.14 74.11,122.3 74.1,122.61 L76.38,122.61 C76.36,122.3 76.34,122.14 76.24,121.92 L76.24,121.92 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.26,132.88 C40.75,133.38 40.83,134.19 40.83,135.02 C40.83,135.85 40.75,136.67 40.26,137.17 C39.98,137.45 39.55,137.62 39.03,137.62 C38.51,137.62 38.07,137.49 37.7,137.04 L37.7,139.61 L36.68,139.61 L36.68,132.49 L37.68,132.49 L37.68,133.03 C38.06,132.57 38.48,132.43 39.02,132.43 C39.56,132.43 39.98,132.6 40.26,132.88 L40.26,132.88 Z M37.7,135.02 C37.7,135.92 37.83,136.71 38.76,136.71 C39.69,136.71 39.81,135.92 39.81,135.02 C39.81,134.12 39.68,133.34 38.76,133.34 C37.84,133.34 37.7,134.12 37.7,135.02 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.77,132.91 L45,133.68 C44.77,133.45 44.59,133.34 44.24,133.34 C43.69,133.34 43.23,133.78 43.23,134.48 L43.23,137.56 L42.21,137.56 L42.21,132.49 L43.21,132.49 L43.21,133.04 C43.47,132.68 43.99,132.43 44.56,132.43 C45.05,132.43 45.42,132.56 45.77,132.91 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.05,135.32 C47.05,136.2 47.5,136.74 48.34,136.74 C48.91,136.74 49.21,136.58 49.57,136.22 L50.22,136.83 C49.7,137.35 49.21,137.62 48.32,137.62 C47.05,137.62 46.04,136.95 46.04,135.02 C46.04,133.37 46.89,132.43 48.19,132.43 C49.49,132.43 50.34,133.41 50.34,134.89 L50.34,135.32 L47.05,135.32 Z M49.19,133.92 C49.02,133.54 48.67,133.28 48.19,133.28 C47.71,133.28 47.35,133.54 47.18,133.92 C47.08,134.14 47.06,134.3 47.05,134.61 L49.33,134.61 C49.31,134.3 49.29,134.14 49.19,133.92 L49.19,133.92 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "53.56 137.56 52.73 137.56 50.87 132.49 51.95 132.49 53.15 136.06 54.34 132.49 55.42 132.49 53.56 137.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.96,135.32 C56.96,136.2 57.41,136.74 58.25,136.74 C58.82,136.74 59.12,136.58 59.48,136.22 L60.13,136.83 C59.61,137.35 59.12,137.62 58.23,137.62 C56.96,137.62 55.95,136.95 55.95,135.02 C55.95,133.37 56.8,132.43 58.1,132.43 C59.4,132.43 60.25,133.41 60.25,134.89 L60.25,135.32 L56.96,135.32 Z M59.1,133.92 C58.93,133.54 58.58,133.28 58.1,133.28 C57.62,133.28 57.26,133.54 57.09,133.92 C56.99,134.14 56.97,134.3 56.96,134.61 L59.24,134.61 C59.22,134.3 59.2,134.14 59.1,133.92 L59.1,133.92 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.21,132.89 C65.6,133.27 65.72,133.75 65.72,134.32 L65.72,137.56 L64.7,137.56 L64.7,134.47 C64.7,133.68 64.25,133.34 63.68,133.34 C63.11,133.34 62.63,133.69 62.63,134.47 L62.63,137.56 L61.61,137.56 L61.61,132.49 L62.61,132.49 L62.61,133 C62.96,132.62 63.45,132.43 63.96,132.43 C64.47,132.43 64.91,132.6 65.21,132.89 L65.21,132.89 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.43,132.49 L69.41,132.49 L69.41,133.27 L68.43,133.27 L68.43,136.1 C68.43,136.48 68.61,136.69 68.99,136.69 L69.41,136.69 L69.41,137.56 L68.8,137.56 C67.85,137.56 67.41,136.89 67.41,136.15 L67.41,133.27 L66.83,133.27 L66.83,132.49 L67.41,132.49 L67.41,131.04 L68.43,131.04 L68.43,132.49 L68.43,132.49 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.76,131.49 L70.68,131.49 L70.68,130.41 L71.76,130.41 L71.76,131.49 Z M71.73,137.56 L70.71,137.56 L70.71,132.49 L71.73,132.49 L71.73,137.56 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1,135.32 C74.1,136.2 74.55,136.74 75.39,136.74 C75.96,136.74 76.26,136.58 76.62,136.22 L77.27,136.83 C76.75,137.35 76.26,137.62 75.37,137.62 C74.1,137.62 73.09,136.95 73.09,135.02 C73.09,133.37 73.94,132.43 75.24,132.43 C76.54,132.43 77.39,133.41 77.39,134.89 L77.39,135.32 L74.1,135.32 Z M76.24,133.92 C76.07,133.54 75.72,133.28 75.24,133.28 C74.76,133.28 74.4,133.54 74.23,133.92 C74.13,134.14 74.11,134.3 74.1,134.61 L76.38,134.61 C76.36,134.3 76.34,134.14 76.24,133.92 L76.24,133.92 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "111.46 94.89 110.43 94.89 108.83 89.4 107.25 94.89 106.22 94.89 104.17 87.06 105.42 87.06 106.78 92.66 108.35 87.06 109.31 87.06 110.88 92.66 112.24 87.06 113.49 87.06 111.44 94.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.24,89.74 C118.78,90.29 118.87,91.18 118.87,92.09 C118.87,93 118.78,93.9 118.24,94.46 C117.93,94.77 117.46,94.96 116.89,94.96 C116.32,94.96 115.83,94.82 115.43,94.32 L115.43,97.15 L114.31,97.15 L114.31,89.32 L115.41,89.32 L115.41,89.91 C115.83,89.4 116.29,89.25 116.88,89.25 C117.47,89.25 117.94,89.44 118.24,89.75 L118.24,89.74 Z M115.42,92.09 C115.42,93.08 115.56,93.95 116.59,93.95 C117.62,93.95 117.74,93.08 117.74,92.09 C117.74,91.1 117.6,90.24 116.59,90.24 C115.58,90.24 115.42,91.1 115.42,92.09 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.55,89.9 L123.55,89.31 L124.64,89.31 L124.64,94.85 C124.64,96.21 123.74,97.2 122.25,97.2 C121.4,97.2 120.86,97 120.28,96.46 L121,95.75 C121.35,96.08 121.66,96.24 122.21,96.24 C123.16,96.24 123.52,95.57 123.52,94.82 L123.52,94.1 C123.11,94.58 122.65,94.74 122.08,94.74 C121.51,94.74 121.06,94.55 120.75,94.25 C120.21,93.71 120.12,92.93 120.12,91.98 C120.12,91.03 120.21,90.25 120.75,89.71 C121.06,89.4 121.53,89.23 122.09,89.23 C122.68,89.23 123.14,89.38 123.55,89.89 L123.55,89.9 Z M121.24,91.99 C121.24,92.87 121.37,93.74 122.38,93.74 C123.39,93.74 123.51,92.87 123.51,91.99 C123.51,91.11 123.39,90.24 122.38,90.24 C121.37,90.24 121.24,91.11 121.24,91.99 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.58,92.41 C171.58,94.04 170.41,94.95 168.97,94.95 C168.17,94.95 167.61,94.73 167.07,94.19 L167.86,93.41 C168.13,93.69 168.4,93.88 168.97,93.88 C169.85,93.88 170.39,93.34 170.39,92.32 L170.39,87.05 L171.58,87.05 L171.58,92.41 L171.58,92.41 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "172.57 89.31 173.76 89.31 174.85 93.24 176.13 89.31 177.01 89.31 178.29 93.24 179.38 89.31 180.58 89.31 178.84 94.89 177.87 94.89 176.57 90.86 175.27 94.89 174.31 94.89 172.57 89.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "231.75 94.89 230.72 94.89 229.12 89.4 227.54 94.89 226.51 94.89 224.46 87.06 225.71 87.06 227.07 92.66 228.64 87.06 229.6 87.06 231.17 92.66 232.53 87.06 233.78 87.06 231.73 94.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.91,89.75 C242.34,90.17 242.5,90.7 242.5,91.32 L242.5,94.88 L241.38,94.88 L241.38,91.48 C241.38,90.61 240.88,90.24 240.26,90.24 C239.64,90.24 239.1,90.62 239.1,91.43 L239.1,94.89 L237.98,94.89 L237.98,91.49 C237.98,90.62 237.48,90.25 236.86,90.25 C236.24,90.25 235.7,90.63 235.7,91.49 L235.7,94.89 L234.58,94.89 L234.58,89.31 L235.68,89.31 L235.68,89.87 C236.05,89.46 236.6,89.24 237.17,89.24 C237.86,89.24 238.4,89.52 238.75,90.05 C239.2,89.5 239.76,89.24 240.5,89.24 C241.07,89.24 241.58,89.43 241.91,89.75 L241.91,89.75 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.96,89.9 C248.49,90.45 248.62,91.15 248.62,92.09 C248.62,93.03 248.49,93.74 247.96,94.29 C247.6,94.66 247.05,94.95 246.29,94.95 C245.53,94.95 244.99,94.66 244.63,94.29 C244.1,93.74 243.97,93.03 243.97,92.09 C243.97,91.15 244.1,90.45 244.63,89.9 C244.99,89.53 245.53,89.24 246.29,89.24 C247.05,89.24 247.6,89.53 247.96,89.9 Z M245.47,90.56 C245.13,90.9 245.08,91.48 245.08,92.09 C245.08,92.7 245.12,93.28 245.47,93.62 C245.68,93.83 245.95,93.95 246.28,93.95 C246.61,93.95 246.9,93.83 247.11,93.62 C247.45,93.28 247.5,92.7 247.5,92.09 C247.5,91.48 247.46,90.9 247.11,90.56 C246.9,90.35 246.61,90.24 246.28,90.24 C245.95,90.24 245.68,90.35 245.47,90.56 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "295.66 88.02 292.03 93.82 295.66 93.82 295.66 94.89 290.64 94.89 290.64 93.92 294.27 88.12 290.79 88.12 290.79 87.05 295.65 87.05 295.65 88.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "299.14 94.89 298.23 94.89 296.18 89.31 297.37 89.31 298.69 93.24 300 89.31 301.19 89.31 299.14 94.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "301.38 89.31 302.57 89.31 303.66 93.24 304.94 89.31 305.82 89.31 307.1 93.24 308.19 89.31 309.39 89.31 307.65 94.89 306.68 94.89 305.38 90.86 304.08 94.89 303.12 94.89 301.38 89.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "361.14 94.89 360.11 94.89 358.52 89.4 356.94 94.89 355.91 94.89 353.86 87.06 355.11 87.06 356.47 92.66 358.04 87.06 359 87.06 360.57 92.66 361.93 87.06 363.18 87.06 361.13 94.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.25,93.1 C365.25,93.69 365.4,93.89 365.86,93.89 L366.36,93.89 L366.36,94.89 L365.74,94.89 C364.66,94.89 364.13,94.3 364.13,93.16 L364.13,87.05 L365.25,87.05 L365.25,93.09 L365.25,93.1 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "367.17 94.02 369.93 90.31 367.32 90.31 367.32 89.31 371.32 89.31 371.32 90.18 368.55 93.89 371.32 93.89 371.32 94.89 367.16 94.89 367.16 94.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.12,167.54 L36.44,168.22 C36,167.8 35.48,167.67 34.87,167.67 C34.03,167.67 33.58,168.13 33.58,168.78 C33.58,169.04 33.65,169.28 33.84,169.44 C34.02,169.6 34.23,169.7 34.62,169.76 L35.47,169.89 C36.12,169.99 36.48,170.14 36.79,170.42 C37.17,170.77 37.37,171.26 37.37,171.88 C37.37,173.19 36.31,173.97 34.81,173.97 C33.74,173.97 32.98,173.72 32.29,173.03 L33,172.32 C33.52,172.84 34.11,173.01 34.83,173.01 C35.77,173.01 36.3,172.61 36.3,171.91 C36.3,171.59 36.22,171.34 36.02,171.17 C35.84,171.01 35.6,170.92 35.24,170.87 L34.4,170.75 C33.82,170.66 33.37,170.48 33.06,170.18 C32.71,169.86 32.53,169.4 32.53,168.81 C32.53,167.57 33.43,166.73 34.91,166.73 C35.86,166.73 36.51,166.97 37.12,167.54 L37.12,167.54 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.45,171.67 C39.45,172.55 39.9,173.09 40.74,173.09 C41.31,173.09 41.61,172.93 41.97,172.57 L42.62,173.18 C42.1,173.7 41.61,173.97 40.72,173.97 C39.45,173.97 38.44,173.3 38.44,171.37 C38.44,169.72 39.29,168.78 40.59,168.78 C41.89,168.78 42.74,169.76 42.74,171.24 L42.74,171.67 L39.45,171.67 L39.45,171.67 Z M41.59,170.27 C41.42,169.89 41.07,169.63 40.59,169.63 C40.11,169.63 39.75,169.89 39.58,170.27 C39.48,170.49 39.46,170.65 39.45,170.96 L41.73,170.96 C41.71,170.65 41.69,170.49 41.59,170.27 L41.59,170.27 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.09,172.28 C45.09,172.82 45.23,173 45.64,173 L46.09,173 L46.09,173.91 L45.53,173.91 C44.55,173.91 44.07,173.37 44.07,172.34 L44.07,166.79 L45.09,166.79 L45.09,172.28 L45.09,172.28 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.86,171.67 C47.86,172.55 48.31,173.09 49.15,173.09 C49.72,173.09 50.02,172.93 50.38,172.57 L51.03,173.18 C50.51,173.7 50.02,173.97 49.13,173.97 C47.86,173.97 46.85,173.3 46.85,171.37 C46.85,169.72 47.7,168.78 49,168.78 C50.3,168.78 51.15,169.76 51.15,171.24 L51.15,171.67 L47.86,171.67 L47.86,171.67 Z M50,170.27 C49.83,169.89 49.48,169.63 49,169.63 C48.52,169.63 48.16,169.89 47.99,170.27 C47.89,170.49 47.87,170.65 47.86,170.96 L50.14,170.96 C50.12,170.65 50.1,170.49 50,170.27 L50,170.27 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2,169.49 L55.5,170.17 C55.18,169.82 54.93,169.69 54.53,169.69 C54.13,169.69 53.81,169.85 53.59,170.14 C53.37,170.42 53.29,170.78 53.29,171.37 C53.29,171.96 53.37,172.33 53.59,172.61 C53.81,172.9 54.14,173.06 54.53,173.06 C54.92,173.06 55.18,172.93 55.5,172.58 L56.2,173.25 C55.72,173.76 55.23,173.97 54.53,173.97 C53.39,173.97 52.27,173.27 52.27,171.37 C52.27,169.47 53.39,168.78 54.53,168.78 C55.23,168.78 55.72,168.98 56.2,169.49 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.52,168.84 L59.5,168.84 L59.5,169.62 L58.52,169.62 L58.52,172.45 C58.52,172.83 58.7,173.04 59.08,173.04 L59.5,173.04 L59.5,173.91 L58.89,173.91 C57.94,173.91 57.5,173.24 57.5,172.5 L57.5,169.62 L56.92,169.62 L56.92,168.84 L57.5,168.84 L57.5,167.39 L58.52,167.39 L58.52,168.84 L58.52,168.84 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.85,167.84 L60.77,167.84 L60.77,166.76 L61.85,166.76 L61.85,167.84 Z M61.82,173.91 L60.8,173.91 L60.8,168.84 L61.82,168.84 L61.82,173.91 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.19,171.67 C64.19,172.55 64.64,173.09 65.48,173.09 C66.05,173.09 66.35,172.93 66.71,172.57 L67.36,173.18 C66.84,173.7 66.35,173.97 65.46,173.97 C64.19,173.97 63.18,173.3 63.18,171.37 C63.18,169.72 64.03,168.78 65.33,168.78 C66.63,168.78 67.48,169.76 67.48,171.24 L67.48,171.67 L64.19,171.67 L64.19,171.67 Z M66.33,170.27 C66.16,169.89 65.81,169.63 65.33,169.63 C64.85,169.63 64.49,169.89 64.32,170.27 C64.22,170.49 64.2,170.65 64.19,170.96 L66.47,170.96 C66.45,170.65 66.43,170.49 66.33,170.27 L66.33,170.27 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "70.7 173.91 69.87 173.91 68.01 168.84 69.09 168.84 70.29 172.41 71.48 168.84 72.56 168.84 70.7 173.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1,171.67 C74.1,172.55 74.55,173.09 75.39,173.09 C75.96,173.09 76.26,172.93 76.62,172.57 L77.27,173.18 C76.75,173.7 76.26,173.97 75.37,173.97 C74.1,173.97 73.09,173.3 73.09,171.37 C73.09,169.72 73.94,168.78 75.24,168.78 C76.54,168.78 77.39,169.76 77.39,171.24 L77.39,171.67 L74.1,171.67 L74.1,171.67 Z M76.24,170.27 C76.07,169.89 75.72,169.63 75.24,169.63 C74.76,169.63 74.4,169.89 74.23,170.27 C74.13,170.49 74.11,170.65 74.1,170.96 L76.38,170.96 C76.36,170.65 76.34,170.49 76.24,170.27 L76.24,170.27 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.26,181.23 C40.75,181.73 40.83,182.54 40.83,183.37 C40.83,184.2 40.75,185.02 40.26,185.52 C39.98,185.8 39.55,185.97 39.03,185.97 C38.51,185.97 38.07,185.84 37.7,185.39 L37.7,187.96 L36.68,187.96 L36.68,180.84 L37.68,180.84 L37.68,181.38 C38.06,180.92 38.48,180.78 39.02,180.78 C39.56,180.78 39.98,180.95 40.26,181.23 L40.26,181.23 Z M37.7,183.37 C37.7,184.27 37.83,185.06 38.76,185.06 C39.69,185.06 39.81,184.27 39.81,183.37 C39.81,182.47 39.68,181.69 38.76,181.69 C37.84,181.69 37.7,182.47 37.7,183.37 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.77,181.26 L45,182.03 C44.77,181.8 44.59,181.69 44.24,181.69 C43.69,181.69 43.23,182.13 43.23,182.83 L43.23,185.91 L42.21,185.91 L42.21,180.84 L43.21,180.84 L43.21,181.39 C43.47,181.03 43.99,180.78 44.56,180.78 C45.05,180.78 45.42,180.91 45.77,181.26 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.05,183.67 C47.05,184.55 47.5,185.09 48.34,185.09 C48.91,185.09 49.21,184.93 49.57,184.57 L50.22,185.18 C49.7,185.7 49.21,185.97 48.32,185.97 C47.05,185.97 46.04,185.3 46.04,183.37 C46.04,181.72 46.89,180.78 48.19,180.78 C49.49,180.78 50.34,181.76 50.34,183.24 L50.34,183.67 L47.05,183.67 L47.05,183.67 Z M49.19,182.27 C49.02,181.89 48.67,181.63 48.19,181.63 C47.71,181.63 47.35,181.89 47.18,182.27 C47.08,182.49 47.06,182.65 47.05,182.96 L49.33,182.96 C49.31,182.65 49.29,182.49 49.19,182.27 L49.19,182.27 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "53.56 185.91 52.73 185.91 50.87 180.84 51.95 180.84 53.15 184.41 54.34 180.84 55.42 180.84 53.56 185.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.96,183.67 C56.96,184.55 57.41,185.09 58.25,185.09 C58.82,185.09 59.12,184.93 59.48,184.57 L60.13,185.18 C59.61,185.7 59.12,185.97 58.23,185.97 C56.96,185.97 55.95,185.3 55.95,183.37 C55.95,181.72 56.8,180.78 58.1,180.78 C59.4,180.78 60.25,181.76 60.25,183.24 L60.25,183.67 L56.96,183.67 L56.96,183.67 Z M59.1,182.27 C58.93,181.89 58.58,181.63 58.1,181.63 C57.62,181.63 57.26,181.89 57.09,182.27 C56.99,182.49 56.97,182.65 56.96,182.96 L59.24,182.96 C59.22,182.65 59.2,182.49 59.1,182.27 L59.1,182.27 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.21,181.24 C65.6,181.62 65.72,182.1 65.72,182.67 L65.72,185.91 L64.7,185.91 L64.7,182.82 C64.7,182.03 64.25,181.69 63.68,181.69 C63.11,181.69 62.63,182.04 62.63,182.82 L62.63,185.91 L61.61,185.91 L61.61,180.84 L62.61,180.84 L62.61,181.35 C62.96,180.97 63.45,180.78 63.96,180.78 C64.47,180.78 64.91,180.95 65.21,181.24 L65.21,181.24 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.43,180.84 L69.41,180.84 L69.41,181.62 L68.43,181.62 L68.43,184.45 C68.43,184.83 68.61,185.04 68.99,185.04 L69.41,185.04 L69.41,185.91 L68.8,185.91 C67.85,185.91 67.41,185.24 67.41,184.5 L67.41,181.62 L66.83,181.62 L66.83,180.84 L67.41,180.84 L67.41,179.39 L68.43,179.39 L68.43,180.84 L68.43,180.84 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.76,179.84 L70.68,179.84 L70.68,178.76 L71.76,178.76 L71.76,179.84 Z M71.73,185.91 L70.71,185.91 L70.71,180.84 L71.73,180.84 L71.73,185.91 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1,183.67 C74.1,184.55 74.55,185.09 75.39,185.09 C75.96,185.09 76.26,184.93 76.62,184.57 L77.27,185.18 C76.75,185.7 76.26,185.97 75.37,185.97 C74.1,185.97 73.09,185.3 73.09,183.37 C73.09,181.72 73.94,180.78 75.24,180.78 C76.54,180.78 77.39,181.76 77.39,183.24 L77.39,183.67 L74.1,183.67 L74.1,183.67 Z M76.24,182.27 C76.07,181.89 75.72,181.63 75.24,181.63 C74.76,181.63 74.4,181.89 74.23,182.27 C74.13,182.49 74.11,182.65 74.1,182.96 L76.38,182.96 C76.36,182.65 76.34,182.49 76.24,182.27 L76.24,182.27 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.83,218.88 L23.75,218.88 C23.57,218.1 23.05,217.65 22.25,217.65 C21.82,217.65 21.46,217.8 21.19,218.08 C20.84,218.46 20.77,218.89 20.77,220.3 C20.77,221.71 20.84,222.14 21.19,222.52 C21.46,222.8 21.82,222.95 22.25,222.95 C22.72,222.95 23.14,222.78 23.42,222.45 C23.68,222.15 23.77,221.79 23.77,221.33 L23.77,220.93 L22.25,220.93 L22.25,220.01 L24.85,220.01 L24.85,221.1 C24.85,222.03 24.68,222.6 24.21,223.11 C23.68,223.67 23,223.92 22.25,223.92 C21.5,223.92 20.87,223.66 20.41,223.2 C19.72,222.5 19.69,221.79 19.69,220.3 C19.69,218.81 19.72,218.1 20.41,217.4 C20.87,216.94 21.47,216.68 22.25,216.68 C23.75,216.68 24.64,217.67 24.83,218.88 L24.83,218.88 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.07,221.62 C27.07,222.5 27.52,223.04 28.36,223.04 C28.93,223.04 29.23,222.88 29.59,222.52 L30.24,223.13 C29.72,223.65 29.23,223.92 28.34,223.92 C27.07,223.92 26.06,223.25 26.06,221.32 C26.06,219.67 26.91,218.73 28.21,218.73 C29.51,218.73 30.36,219.71 30.36,221.19 L30.36,221.62 L27.07,221.62 L27.07,221.62 Z M29.21,220.22 C29.04,219.84 28.69,219.58 28.21,219.58 C27.73,219.58 27.37,219.84 27.2,220.22 C27.1,220.44 27.08,220.6 27.07,220.91 L29.35,220.91 C29.33,220.6 29.31,220.44 29.21,220.22 L29.21,220.22 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.62,217.82 L30.7,217.82 L30.7,216.74 L31.62,216.74 L31.62,217.82 Z M32.74,223.86 L31.72,223.86 L31.72,218.79 L32.74,218.79 L32.74,223.86 Z M33.78,217.82 L32.86,217.82 L32.86,216.74 L33.78,216.74 L33.78,217.82 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.96,219.19 C38.35,219.57 38.47,220.05 38.47,220.62 L38.47,223.86 L37.45,223.86 L37.45,220.77 C37.45,219.98 37,219.64 36.43,219.64 C35.86,219.64 35.38,219.99 35.38,220.77 L35.38,223.86 L34.36,223.86 L34.36,218.79 L35.36,218.79 L35.36,219.3 C35.71,218.92 36.2,218.73 36.71,218.73 C37.22,218.73 37.66,218.9 37.96,219.19 L37.96,219.19 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.95,223.86 L42.95,223.86 L42.95,223.32 C42.57,223.78 42.15,223.92 41.61,223.92 C41.07,223.92 40.65,223.75 40.37,223.47 C39.88,222.97 39.8,222.16 39.8,221.33 C39.8,220.5 39.88,219.68 40.37,219.18 C40.65,218.9 41.08,218.73 41.6,218.73 C42.12,218.73 42.56,218.86 42.93,219.31 L42.93,216.74 L43.95,216.74 L43.95,223.86 L43.95,223.86 Z M40.82,221.33 C40.82,222.23 40.95,223.01 41.87,223.01 C42.79,223.01 42.93,222.23 42.93,221.33 C42.93,220.43 42.8,219.64 41.87,219.64 C40.94,219.64 40.82,220.43 40.82,221.33 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.62,217.79 L45.54,217.79 L45.54,216.71 L46.62,216.71 L46.62,217.79 Z M46.59,223.86 L45.57,223.86 L45.57,218.79 L46.59,218.79 L46.59,223.86 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9,219.44 L51.2,220.12 C50.88,219.77 50.63,219.64 50.23,219.64 C49.83,219.64 49.51,219.8 49.29,220.09 C49.07,220.37 48.99,220.73 48.99,221.32 C48.99,221.91 49.07,222.28 49.29,222.56 C49.51,222.85 49.84,223.01 50.23,223.01 C50.62,223.01 50.88,222.88 51.2,222.53 L51.9,223.2 C51.42,223.71 50.93,223.92 50.23,223.92 C49.09,223.92 47.97,223.22 47.97,221.32 C47.97,219.42 49.09,218.73 50.23,218.73 C50.93,218.73 51.42,218.93 51.9,219.44 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.68,221.62 C53.68,222.5 54.13,223.04 54.97,223.04 C55.54,223.04 55.84,222.88 56.2,222.52 L56.85,223.13 C56.33,223.65 55.84,223.92 54.95,223.92 C53.68,223.92 52.67,223.25 52.67,221.32 C52.67,219.67 53.52,218.73 54.82,218.73 C56.12,218.73 56.97,219.71 56.97,221.19 L56.97,221.62 L53.68,221.62 L53.68,221.62 Z M55.82,220.22 C55.65,219.84 55.3,219.58 54.82,219.58 C54.34,219.58 53.98,219.84 53.81,220.22 C53.71,220.44 53.69,220.6 53.68,220.91 L55.96,220.91 C55.94,220.6 55.92,220.44 55.82,220.22 L55.82,220.22 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.08,221.62 C59.08,222.5 59.53,223.04 60.37,223.04 C60.94,223.04 61.24,222.88 61.6,222.52 L62.25,223.13 C61.73,223.65 61.24,223.92 60.35,223.92 C59.08,223.92 58.07,223.25 58.07,221.32 C58.07,219.67 58.92,218.73 60.22,218.73 C61.52,218.73 62.37,219.71 62.37,221.19 L62.37,221.62 L59.08,221.62 L59.08,221.62 Z M61.22,220.22 C61.05,219.84 60.7,219.58 60.22,219.58 C59.74,219.58 59.38,219.84 59.21,220.22 C59.11,220.44 59.09,220.6 59.08,220.91 L61.36,220.91 C61.34,220.6 61.32,220.44 61.22,220.22 L61.22,220.22 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.29,219.21 L66.52,219.98 C66.29,219.75 66.11,219.64 65.76,219.64 C65.21,219.64 64.75,220.08 64.75,220.78 L64.75,223.86 L63.73,223.86 L63.73,218.79 L64.73,218.79 L64.73,219.34 C64.99,218.98 65.51,218.73 66.08,218.73 C66.57,218.73 66.94,218.86 67.29,219.21 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.73,223.86 L70.73,223.86 L70.73,223.32 C70.35,223.78 69.93,223.92 69.39,223.92 C68.85,223.92 68.43,223.75 68.15,223.47 C67.66,222.97 67.58,222.16 67.58,221.33 C67.58,220.5 67.66,219.68 68.15,219.18 C68.43,218.9 68.86,218.73 69.38,218.73 C69.9,218.73 70.34,218.86 70.71,219.31 L70.71,216.74 L71.73,216.74 L71.73,223.86 L71.73,223.86 Z M68.6,221.33 C68.6,222.23 68.73,223.01 69.65,223.01 C70.57,223.01 70.71,222.23 70.71,221.33 C70.71,220.43 70.58,219.64 69.65,219.64 C68.72,219.64 68.6,220.43 68.6,221.33 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1,221.62 C74.1,222.5 74.55,223.04 75.39,223.04 C75.96,223.04 76.26,222.88 76.62,222.52 L77.27,223.13 C76.75,223.65 76.26,223.92 75.37,223.92 C74.1,223.92 73.09,223.25 73.09,221.32 C73.09,219.67 73.94,218.73 75.24,218.73 C76.54,218.73 77.39,219.71 77.39,221.19 L77.39,221.62 L74.1,221.62 L74.1,221.62 Z M76.24,220.22 C76.07,219.84 75.72,219.58 75.24,219.58 C74.76,219.58 74.4,219.84 74.23,220.22 C74.13,220.44 74.11,220.6 74.1,220.91 L76.38,220.91 C76.36,220.6 76.34,220.44 76.24,220.22 L76.24,220.22 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.26,231.18 C40.75,231.68 40.83,232.49 40.83,233.32 C40.83,234.15 40.75,234.97 40.26,235.47 C39.98,235.75 39.55,235.92 39.03,235.92 C38.51,235.92 38.07,235.79 37.7,235.34 L37.7,237.91 L36.68,237.91 L36.68,230.79 L37.68,230.79 L37.68,231.33 C38.06,230.87 38.48,230.73 39.02,230.73 C39.56,230.73 39.98,230.9 40.26,231.18 L40.26,231.18 Z M37.7,233.32 C37.7,234.22 37.83,235.01 38.76,235.01 C39.69,235.01 39.81,234.22 39.81,233.32 C39.81,232.42 39.68,231.64 38.76,231.64 C37.84,231.64 37.7,232.42 37.7,233.32 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.77,231.21 L45,231.98 C44.77,231.75 44.59,231.64 44.24,231.64 C43.69,231.64 43.23,232.08 43.23,232.78 L43.23,235.86 L42.21,235.86 L42.21,230.79 L43.21,230.79 L43.21,231.34 C43.47,230.98 43.99,230.73 44.56,230.73 C45.05,230.73 45.42,230.86 45.77,231.21 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.05,233.62 C47.05,234.5 47.5,235.04 48.34,235.04 C48.91,235.04 49.21,234.88 49.57,234.52 L50.22,235.13 C49.7,235.65 49.21,235.92 48.32,235.92 C47.05,235.92 46.04,235.25 46.04,233.32 C46.04,231.67 46.89,230.73 48.19,230.73 C49.49,230.73 50.34,231.71 50.34,233.19 L50.34,233.62 L47.05,233.62 L47.05,233.62 Z M49.19,232.22 C49.02,231.84 48.67,231.58 48.19,231.58 C47.71,231.58 47.35,231.84 47.18,232.22 C47.08,232.44 47.06,232.6 47.05,232.91 L49.33,232.91 C49.31,232.6 49.29,232.44 49.19,232.22 L49.19,232.22 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "53.56 235.86 52.73 235.86 50.87 230.79 51.95 230.79 53.15 234.36 54.34 230.79 55.42 230.79 53.56 235.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.96,233.62 C56.96,234.5 57.41,235.04 58.25,235.04 C58.82,235.04 59.12,234.88 59.48,234.52 L60.13,235.13 C59.61,235.65 59.12,235.92 58.23,235.92 C56.96,235.92 55.95,235.25 55.95,233.32 C55.95,231.67 56.8,230.73 58.1,230.73 C59.4,230.73 60.25,231.71 60.25,233.19 L60.25,233.62 L56.96,233.62 L56.96,233.62 Z M59.1,232.22 C58.93,231.84 58.58,231.58 58.1,231.58 C57.62,231.58 57.26,231.84 57.09,232.22 C56.99,232.44 56.97,232.6 56.96,232.91 L59.24,232.91 C59.22,232.6 59.2,232.44 59.1,232.22 L59.1,232.22 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.21,231.19 C65.6,231.57 65.72,232.05 65.72,232.62 L65.72,235.86 L64.7,235.86 L64.7,232.77 C64.7,231.98 64.25,231.64 63.68,231.64 C63.11,231.64 62.63,231.99 62.63,232.77 L62.63,235.86 L61.61,235.86 L61.61,230.79 L62.61,230.79 L62.61,231.3 C62.96,230.92 63.45,230.73 63.96,230.73 C64.47,230.73 64.91,230.9 65.21,231.19 L65.21,231.19 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.43,230.79 L69.41,230.79 L69.41,231.57 L68.43,231.57 L68.43,234.4 C68.43,234.78 68.61,234.99 68.99,234.99 L69.41,234.99 L69.41,235.86 L68.8,235.86 C67.85,235.86 67.41,235.19 67.41,234.45 L67.41,231.57 L66.83,231.57 L66.83,230.79 L67.41,230.79 L67.41,229.34 L68.43,229.34 L68.43,230.79 L68.43,230.79 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.76,229.79 L70.68,229.79 L70.68,228.71 L71.76,228.71 L71.76,229.79 Z M71.73,235.86 L70.71,235.86 L70.71,230.79 L71.73,230.79 L71.73,235.86 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1,233.62 C74.1,234.5 74.55,235.04 75.39,235.04 C75.96,235.04 76.26,234.88 76.62,234.52 L77.27,235.13 C76.75,235.65 76.26,235.92 75.37,235.92 C74.1,235.92 73.09,235.25 73.09,233.32 C73.09,231.67 73.94,230.73 75.24,230.73 C76.54,230.73 77.39,231.71 77.39,233.19 L77.39,233.62 L74.1,233.62 L74.1,233.62 Z M76.24,232.22 C76.07,231.84 75.72,231.58 75.24,231.58 C74.76,231.58 74.4,231.84 74.23,232.22 C74.13,232.44 74.11,232.6 74.1,232.91 L76.38,232.91 C76.36,232.6 76.34,232.44 76.24,232.22 L76.24,232.22 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "4.56 264.32 1.26 269.59 4.56 269.59 4.56 270.56 -2.84217094e-14 270.56 -2.84217094e-14 269.68 3.3 264.41 0.14 264.41 0.14 263.44 4.56 263.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21,266.03 C9.69,266.53 9.81,267.17 9.81,268.02 C9.81,268.87 9.69,269.52 9.21,270.02 C8.88,270.36 8.38,270.62 7.69,270.62 C7,270.62 6.51,270.36 6.18,270.02 C5.7,269.52 5.58,268.88 5.58,268.02 C5.58,267.16 5.7,266.53 6.18,266.03 C6.51,265.69 7,265.43 7.69,265.43 C8.38,265.43 8.88,265.69 9.21,266.03 Z M6.95,266.63 C6.64,266.94 6.6,267.47 6.6,268.02 C6.6,268.57 6.64,269.1 6.95,269.41 C7.14,269.6 7.39,269.71 7.69,269.71 C7.99,269.71 8.25,269.6 8.44,269.41 C8.75,269.1 8.79,268.57 8.79,268.02 C8.79,267.47 8.75,266.94 8.44,266.63 C8.25,266.44 7.99,266.34 7.69,266.34 C7.39,266.34 7.14,266.44 6.95,266.63 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75,265.91 L13.98,266.68 C13.75,266.45 13.57,266.34 13.22,266.34 C12.67,266.34 12.21,266.78 12.21,267.48 L12.21,270.56 L11.19,270.56 L11.19,265.49 L12.19,265.49 L12.19,266.04 C12.45,265.68 12.97,265.43 13.54,265.43 C14.03,265.43 14.4,265.56 14.75,265.91 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.16,266.03 L18.16,265.49 L19.15,265.49 L19.15,270.53 C19.15,271.77 18.33,272.67 16.98,272.67 C16.21,272.67 15.72,272.49 15.19,272 L15.84,271.35 C16.16,271.65 16.44,271.8 16.94,271.8 C17.8,271.8 18.13,271.19 18.13,270.51 L18.13,269.86 C17.76,270.3 17.34,270.44 16.82,270.44 C16.3,270.44 15.89,270.27 15.61,269.99 C15.12,269.5 15.04,268.79 15.04,267.93 C15.04,267.07 15.12,266.36 15.61,265.87 C15.89,265.59 16.32,265.43 16.83,265.43 C17.37,265.43 17.78,265.57 18.16,266.03 L18.16,266.03 Z M16.06,267.93 C16.06,268.73 16.18,269.52 17.1,269.52 C18.02,269.52 18.13,268.73 18.13,267.93 C18.13,267.13 18.02,266.34 17.1,266.34 C16.18,266.34 16.06,267.13 16.06,267.93 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.65,266.03 L23.65,265.49 L24.64,265.49 L24.64,270.53 C24.64,271.77 23.82,272.67 22.47,272.67 C21.7,272.67 21.21,272.49 20.68,272 L21.33,271.35 C21.65,271.65 21.93,271.8 22.43,271.8 C23.29,271.8 23.62,271.19 23.62,270.51 L23.62,269.86 C23.25,270.3 22.83,270.44 22.31,270.44 C21.79,270.44 21.38,270.27 21.1,269.99 C20.61,269.5 20.53,268.79 20.53,267.93 C20.53,267.07 20.61,266.36 21.1,265.87 C21.38,265.59 21.81,265.43 22.32,265.43 C22.86,265.43 23.27,265.57 23.65,266.03 L23.65,266.03 Z M21.55,267.93 C21.55,268.73 21.67,269.52 22.59,269.52 C23.51,269.52 23.62,268.73 23.62,267.93 C23.62,267.13 23.51,266.34 22.59,266.34 C21.67,266.34 21.55,267.13 21.55,267.93 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.01,268.32 C27.01,269.2 27.46,269.74 28.3,269.74 C28.87,269.74 29.17,269.58 29.53,269.22 L30.18,269.83 C29.66,270.35 29.17,270.62 28.28,270.62 C27.01,270.62 26,269.95 26,268.02 C26,266.37 26.85,265.43 28.15,265.43 C29.45,265.43 30.3,266.41 30.3,267.89 L30.3,268.32 L27.01,268.32 L27.01,268.32 Z M29.15,266.92 C28.98,266.54 28.63,266.28 28.15,266.28 C27.67,266.28 27.31,266.54 27.14,266.92 C27.04,267.14 27.02,267.3 27.01,267.61 L29.29,267.61 C29.27,267.3 29.25,267.14 29.15,266.92 L29.15,266.92 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.22,265.91 L34.45,266.68 C34.22,266.45 34.04,266.34 33.69,266.34 C33.14,266.34 32.68,266.78 32.68,267.48 L32.68,270.56 L31.66,270.56 L31.66,265.49 L32.66,265.49 L32.66,266.04 C32.92,265.68 33.44,265.43 34.01,265.43 C34.5,265.43 34.87,265.56 35.22,265.91 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5,268.32 C36.5,269.2 36.95,269.74 37.79,269.74 C38.36,269.74 38.66,269.58 39.02,269.22 L39.67,269.83 C39.15,270.35 38.66,270.62 37.77,270.62 C36.5,270.62 35.49,269.95 35.49,268.02 C35.49,266.37 36.34,265.43 37.64,265.43 C38.94,265.43 39.79,266.41 39.79,267.89 L39.79,268.32 L36.5,268.32 L36.5,268.32 Z M38.64,266.92 C38.47,266.54 38.12,266.28 37.64,266.28 C37.16,266.28 36.8,266.54 36.63,266.92 C36.53,267.14 36.51,267.3 36.5,267.61 L38.78,267.61 C38.76,267.3 38.74,267.14 38.64,266.92 L38.64,266.92 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.14,268.93 C42.14,269.47 42.28,269.65 42.69,269.65 L43.14,269.65 L43.14,270.56 L42.58,270.56 C41.6,270.56 41.12,270.02 41.12,268.99 L41.12,263.44 L42.14,263.44 L42.14,268.93 L42.14,268.93 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.99,267.17 L47.99,270.56 L46.99,270.56 L46.99,270.1 C46.62,270.47 46.27,270.62 45.64,270.62 C45.01,270.62 44.59,270.47 44.28,270.16 C44.02,269.89 43.88,269.5 43.88,269.07 C43.88,268.22 44.47,267.61 45.64,267.61 L46.97,267.61 L46.97,267.25 C46.97,266.6 46.66,266.3 45.86,266.3 C45.32,266.3 45.04,266.44 44.75,266.8 L44.09,266.17 C44.56,265.61 45.05,265.43 45.9,265.43 C47.3,265.43 47.99,266.03 47.99,267.17 L47.99,267.17 Z M45.8,268.32 C45.18,268.32 44.87,268.58 44.87,269.05 C44.87,269.52 45.16,269.77 45.83,269.77 C46.19,269.77 46.48,269.73 46.75,269.48 C46.91,269.33 46.97,269.09 46.97,268.73 L46.97,268.32 L45.8,268.32 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7,265.49 L51.68,265.49 L51.68,266.27 L50.7,266.27 L50.7,269.1 C50.7,269.48 50.88,269.69 51.26,269.69 L51.68,269.69 L51.68,270.56 L51.07,270.56 C50.12,270.56 49.68,269.89 49.68,269.15 L49.68,266.27 L49.1,266.27 L49.1,265.49 L49.68,265.49 L49.68,264.04 L50.7,264.04 L50.7,265.49 L50.7,265.49 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.68,268.32 C53.68,269.2 54.13,269.74 54.97,269.74 C55.54,269.74 55.84,269.58 56.2,269.22 L56.85,269.83 C56.33,270.35 55.84,270.62 54.95,270.62 C53.68,270.62 52.67,269.95 52.67,268.02 C52.67,266.37 53.52,265.43 54.82,265.43 C56.12,265.43 56.97,266.41 56.97,267.89 L56.97,268.32 L53.68,268.32 L53.68,268.32 Z M55.82,266.92 C55.65,266.54 55.3,266.28 54.82,266.28 C54.34,266.28 53.98,266.54 53.81,266.92 C53.71,267.14 53.69,267.3 53.68,267.61 L55.96,267.61 C55.94,267.3 55.92,267.14 55.82,266.92 L55.82,266.92 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.08,268.32 C59.08,269.2 59.53,269.74 60.37,269.74 C60.94,269.74 61.24,269.58 61.6,269.22 L62.25,269.83 C61.73,270.35 61.24,270.62 60.35,270.62 C59.08,270.62 58.07,269.95 58.07,268.02 C58.07,266.37 58.92,265.43 60.22,265.43 C61.52,265.43 62.37,266.41 62.37,267.89 L62.37,268.32 L59.08,268.32 L59.08,268.32 Z M61.22,266.92 C61.05,266.54 60.7,266.28 60.22,266.28 C59.74,266.28 59.38,266.54 59.21,266.92 C59.11,267.14 59.09,267.3 59.08,267.61 L61.36,267.61 C61.34,267.3 61.32,267.14 61.22,266.92 L61.22,266.92 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.29,265.91 L66.52,266.68 C66.29,266.45 66.11,266.34 65.76,266.34 C65.21,266.34 64.75,266.78 64.75,267.48 L64.75,270.56 L63.73,270.56 L63.73,265.49 L64.73,265.49 L64.73,266.04 C64.99,265.68 65.51,265.43 66.08,265.43 C66.57,265.43 66.94,265.56 67.29,265.91 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.73,270.56 L70.73,270.56 L70.73,270.02 C70.35,270.48 69.93,270.62 69.39,270.62 C68.85,270.62 68.43,270.45 68.15,270.17 C67.66,269.67 67.58,268.86 67.58,268.03 C67.58,267.2 67.66,266.38 68.15,265.88 C68.43,265.6 68.86,265.43 69.38,265.43 C69.9,265.43 70.34,265.56 70.71,266.01 L70.71,263.44 L71.73,263.44 L71.73,270.56 L71.73,270.56 Z M68.6,268.03 C68.6,268.93 68.73,269.71 69.65,269.71 C70.57,269.71 70.71,268.93 70.71,268.03 C70.71,267.13 70.58,266.34 69.65,266.34 C68.72,266.34 68.6,267.13 68.6,268.03 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1,268.32 C74.1,269.2 74.55,269.74 75.39,269.74 C75.96,269.74 76.26,269.58 76.62,269.22 L77.27,269.83 C76.75,270.35 76.26,270.62 75.37,270.62 C74.1,270.62 73.09,269.95 73.09,268.02 C73.09,266.37 73.94,265.43 75.24,265.43 C76.54,265.43 77.39,266.41 77.39,267.89 L77.39,268.32 L74.1,268.32 L74.1,268.32 Z M76.24,266.92 C76.07,266.54 75.72,266.28 75.24,266.28 C74.76,266.28 74.4,266.54 74.23,266.92 C74.13,267.14 74.11,267.3 74.1,267.61 L76.38,267.61 C76.36,267.3 76.34,267.14 76.24,266.92 L76.24,266.92 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.26,277.88 C40.75,278.38 40.83,279.19 40.83,280.02 C40.83,280.85 40.75,281.67 40.26,282.17 C39.98,282.45 39.55,282.62 39.03,282.62 C38.51,282.62 38.07,282.49 37.7,282.04 L37.7,284.61 L36.68,284.61 L36.68,277.49 L37.68,277.49 L37.68,278.03 C38.06,277.57 38.48,277.43 39.02,277.43 C39.56,277.43 39.98,277.6 40.26,277.88 L40.26,277.88 Z M37.7,280.02 C37.7,280.92 37.83,281.71 38.76,281.71 C39.69,281.71 39.81,280.92 39.81,280.02 C39.81,279.12 39.68,278.34 38.76,278.34 C37.84,278.34 37.7,279.12 37.7,280.02 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.77,277.91 L45,278.68 C44.77,278.45 44.59,278.34 44.24,278.34 C43.69,278.34 43.23,278.78 43.23,279.48 L43.23,282.56 L42.21,282.56 L42.21,277.49 L43.21,277.49 L43.21,278.04 C43.47,277.68 43.99,277.43 44.56,277.43 C45.05,277.43 45.42,277.56 45.77,277.91 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.05,280.32 C47.05,281.2 47.5,281.74 48.34,281.74 C48.91,281.74 49.21,281.58 49.57,281.22 L50.22,281.83 C49.7,282.35 49.21,282.62 48.32,282.62 C47.05,282.62 46.04,281.95 46.04,280.02 C46.04,278.37 46.89,277.43 48.19,277.43 C49.49,277.43 50.34,278.41 50.34,279.89 L50.34,280.32 L47.05,280.32 L47.05,280.32 Z M49.19,278.92 C49.02,278.54 48.67,278.28 48.19,278.28 C47.71,278.28 47.35,278.54 47.18,278.92 C47.08,279.14 47.06,279.3 47.05,279.61 L49.33,279.61 C49.31,279.3 49.29,279.14 49.19,278.92 L49.19,278.92 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "53.56 282.56 52.73 282.56 50.87 277.49 51.95 277.49 53.15 281.06 54.34 277.49 55.42 277.49 53.56 282.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.96,280.32 C56.96,281.2 57.41,281.74 58.25,281.74 C58.82,281.74 59.12,281.58 59.48,281.22 L60.13,281.83 C59.61,282.35 59.12,282.62 58.23,282.62 C56.96,282.62 55.95,281.95 55.95,280.02 C55.95,278.37 56.8,277.43 58.1,277.43 C59.4,277.43 60.25,278.41 60.25,279.89 L60.25,280.32 L56.96,280.32 L56.96,280.32 Z M59.1,278.92 C58.93,278.54 58.58,278.28 58.1,278.28 C57.62,278.28 57.26,278.54 57.09,278.92 C56.99,279.14 56.97,279.3 56.96,279.61 L59.24,279.61 C59.22,279.3 59.2,279.14 59.1,278.92 L59.1,278.92 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.21,277.89 C65.6,278.27 65.72,278.75 65.72,279.32 L65.72,282.56 L64.7,282.56 L64.7,279.47 C64.7,278.68 64.25,278.34 63.68,278.34 C63.11,278.34 62.63,278.69 62.63,279.47 L62.63,282.56 L61.61,282.56 L61.61,277.49 L62.61,277.49 L62.61,278 C62.96,277.62 63.45,277.43 63.96,277.43 C64.47,277.43 64.91,277.6 65.21,277.89 L65.21,277.89 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.43,277.49 L69.41,277.49 L69.41,278.27 L68.43,278.27 L68.43,281.1 C68.43,281.48 68.61,281.69 68.99,281.69 L69.41,281.69 L69.41,282.56 L68.8,282.56 C67.85,282.56 67.41,281.89 67.41,281.15 L67.41,278.27 L66.83,278.27 L66.83,277.49 L67.41,277.49 L67.41,276.04 L68.43,276.04 L68.43,277.49 L68.43,277.49 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.76,276.49 L70.68,276.49 L70.68,275.41 L71.76,275.41 L71.76,276.49 Z M71.73,282.56 L70.71,282.56 L70.71,277.49 L71.73,277.49 L71.73,282.56 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1,280.32 C74.1,281.2 74.55,281.74 75.39,281.74 C75.96,281.74 76.26,281.58 76.62,281.22 L77.27,281.83 C76.75,282.35 76.26,282.62 75.37,282.62 C74.1,282.62 73.09,281.95 73.09,280.02 C73.09,278.37 73.94,277.43 75.24,277.43 C76.54,277.43 77.39,278.41 77.39,279.89 L77.39,280.32 L74.1,280.32 L74.1,280.32 Z M76.24,278.92 C76.07,278.54 75.72,278.28 75.24,278.28 C74.76,278.28 74.4,278.54 74.23,278.92 C74.13,279.14 74.11,279.3 74.1,279.61 L76.38,279.61 C76.36,279.3 76.34,279.14 76.24,278.92 L76.24,278.92 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreventieWetten);
export default __webpack_public_path__ + "static/media/preventie-wetten.09fcc176cd02e9b1337f34a7a3784d08.svg";
export { ForwardRef as ReactComponent };